const apiVersion = 'v1'
export const BASE_PATH = `api/${apiVersion}/clients/:client_session_id/plps-core/jobs/`
export const BASE_PATH_HISTORICAL = `api/${apiVersion}/clients/:client_session_id/plps-core/job-history-logs`
